import React, { useEffect } from 'react';
import { Container, Grid, Typography, TextField, Button, Box, Select, MenuItem } from '@mui/material';
import { styled } from '@mui/system';

const GradientButton = styled(Button)({
  background: 'linear-gradient(45deg, #233098, #6e3b8f)',
  color: 'white',
  fontWeight: 'bold',
  borderRadius: '20px',
  padding: '10px 20px',
  textTransform: 'none',
  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  '&:hover': {
    background: 'linear-gradient(45deg, #233098, #6e3b8f)',
    transform: 'scale(1.05)',
    boxShadow: '0 6px 10px rgba(0, 0, 0, 0.2)',
  },
});

const BackgroundBox = styled(Box)({
  background: 'linear-gradient(to bottom, #f0f4ff, #e6f0ff)',
  padding: '20px 0',
});

const ServiceDetails = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <BackgroundBox>
      <Container sx={{ fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}>
        <Grid container spacing={4} alignItems="center" mt={1} mb={5} sx={{overflowX:'hidden',overflowY:'hidden'}}>
          <Grid item xs={12} md={6}>
            <Typography variant="h3" sx={{ fontWeight: 'bold', color: '#0a003d', mb: 2, fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", borderBottom: '3px solid #233098', paddingBottom: 1 }}>
              Web Design and Development Services in Bangalore
            </Typography>
            <Typography variant="subtitle1" sx={{ color: '#6c6c6c', mb: 3, fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif", fontStyle: 'italic' }}>
              Delivering Premium Websites at an Affordable Price.
            </Typography>
            <Grid container spacing={1} sx={{ mb: 3 }}>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ display: 'flex', alignItems: 'center', color: '#6c6c6c', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}>
                  <Box component="span" sx={{ mr: 1 }}>📍</Box> Client-Location Development
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ display: 'flex', alignItems: 'center', color: '#6c6c6c', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}>
                  <Box component="span" sx={{ mr: 1 }}>👥</Box> Reliable Support Team
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ display: 'flex', alignItems: 'center', color: '#6c6c6c', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}>
                  <Box component="span" sx={{ mr: 1 }}>⏰</Box> On-Time Project Deliveries
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ display: 'flex', alignItems: 'center', color: '#6c6c6c', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}>
                  <Box component="span" sx={{ mr: 1 }}>💻</Box> Responsive for All Devices
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ display: 'flex', alignItems: 'center', color: '#6c6c6c', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}>
                  <Box component="span" sx={{ mr: 1 }}>🌟</Box> Premium Quality
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography sx={{ display: 'flex', alignItems: 'center', color: '#6c6c6c', fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}>
                  <Box component="span" sx={{ mr: 1 }}>🧑‍💻</Box> Expert Development Team
                </Typography>
              </Grid>
            </Grid>
            <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#0a003d', mb: 2, fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}>
              Grow Your Business Online!
            </Typography>
            <GradientButton>
              Enquiry Now
            </GradientButton>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{ backgroundColor: 'white', borderRadius: '10px', padding: 4, boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
              <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#0a003d', mb: 3, fontFamily: "'Montserrat', Helvetica, Arial, Lucida, sans-serif" }}>
                Contact Our Experts Today!!
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Enter Name" variant="outlined" sx={{ borderRadius: '8px' }} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Enter Mobile" variant="outlined" sx={{ borderRadius: '8px' }} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField fullWidth label="Enter Email" variant="outlined" sx={{ borderRadius: '8px' }} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Select fullWidth displayEmpty variant="outlined" sx={{ borderRadius: '8px' }}>
                    <MenuItem value="" disabled>Select Service</MenuItem>
                    <MenuItem value={1}>Service 1</MenuItem>
                    <MenuItem value={2}>Service 2</MenuItem>
                    <MenuItem value={3}>Service 3</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={12}>
                  <TextField fullWidth label="Enter Your Message" variant="outlined" multiline rows={4} sx={{ borderRadius: '8px' }} />
                </Grid>
                <Grid item xs={12}>
                  <GradientButton fullWidth>
                    Submit
                  </GradientButton>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </BackgroundBox>
  );
};

export default ServiceDetails;
